import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IConfirmEmailForm, IConfirmEmailWithPasswordForm, IResendConfirmEmailForm } from './types';

export const useConfirmEmail = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useConfirmEmail');
  return useMutation<any, DefaultError, IConfirmEmailWithPasswordForm>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.confirm-email.loading'));

      const response = await apiClient({
        method: 'POST',
        url: 'Auth/ConfirmEmail',
        body,
      });

      return responseHandler(response, {
        groupName: 'useConfirmEmail',
      });
    },
    onSuccess(data) {
      success(i18next.t('service-message.auth.confirm-email.success'));
    },
    onError: dismiss,
  });
};
export const useConfirmEmailWithoutPassword = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast(
    'useConfirmEmailWithoutPassword'
  );
  return useMutation<any, DefaultError, IConfirmEmailForm>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.confirm-email.loading'));

      const response = await apiClient({
        method: 'POST',
        url: 'Auth/ConfirmEmailWithoutPassword',
        body,
      });

      return responseHandler(response, {
        groupName: 'useConfirmEmailWithoutPassword',
      });
    },
    onSuccess(data) {
      success(i18next.t('service-message.auth.confirm-email.success'));
    },
    onError: dismiss,
  });
};

export const useResendConfirmEmail = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useResendConfirmEmail');
  return useMutation<any, DefaultError, IResendConfirmEmailForm>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.resend-confirm-email.loading'));

      const response = await apiClient({
        method: 'POST',
        url: 'Auth/ResendConfirmationEmail',
        body,
      });

      return responseHandler(response, {
        groupName: 'useResendConfirmEmail',
      });
    },
    onError: dismiss,
    onSuccess(data) {
      success(i18next.t('service-message.auth.resend-confirm-email.success'));
    },
  });
};
